export default "__VITE_PUBLIC_ASSET__62fac5ce__"